import { render } from "./weeklyRankRewardsRich.vue?vue&type=template&id=3bc38bee"
import script from "./weeklyRankRewardsRich.vue?vue&type=script&lang=js"
export * from "./weeklyRankRewardsRich.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__